import { TeamOutlined } from "@ant-design/icons";
import { useUser } from "@p0security/frontend-core";
import { Flex, Grid, Spacing, Spin, Typography } from "@p0security/ui";
import { useParams } from "react-router";
import { colors } from "styles/variables";

export const LoggedInUserNavItem: React.FC = () => {
  const { user } = useUser();
  const { orgSlug } = useParams();
  const { lg } = Grid.useBreakpoint();

  return lg ? (
    <div className="block px-6 py-4 text-p0-neutral-70 [&_.ant-typography]:m-1! [&_.ant-typography]:text-p0-neutral-70!">
      <Typography.Paragraph>Welcome,</Typography.Paragraph>
      {user ? (
        <Typography.Paragraph strong>
          {user.displayName || user.email}
        </Typography.Paragraph>
      ) : (
        <Spin />
      )}
      {orgSlug && (
        <Spacing mt={4}>
          <Flex align="center" gap={4}>
            <TeamOutlined
              /* eslint-disable-line react/forbid-component-props */ style={{
                fontSize: "14px",
                color: colors.neutral["40"],
              }}
            />
            {/* A long org slug is clipped, and unfurls onto several lines on hover. */}
            <Typography.Text
              className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-p0-neutral-50 text-sm font-medium hover:overflow-visible hover:whitespace-normal"
              title={orgSlug}
            >
              {orgSlug}
            </Typography.Text>
          </Flex>
        </Spacing>
      )}
    </div>
  ) : null;
};
